import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export const isValidDateValue = value => moment(value, 'YYYY-MM-DD', true).isValid();

function PolishDateInput({ label, name, value, readOnly, error, onChange, onBlur }) {
  const displayValue = isValidDateValue(value) ? moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY') : value;
  const changeText = (event) => {
    const text = event.target.value;
    const parsed = moment(text, 'DD.MM.YYYY', true);
    onChange({ target: { name, value: parsed.isValid() ? parsed.format('YYYY-MM-DD') : text } });
  };
  return (
    <div className="form-group">
      <span><strong>{label}</strong></span>
      <div className="input-group mt-1">
        <input
          type="text"
          name={name}
          aria-label={label}
          placeholder="DD.MM.RRRR"
          className={`form-control${error ? ' is-invalid' : ''}`}
          value={displayValue}
          readOnly={readOnly}
          onChange={changeText}
          onBlur={onBlur}
          autoComplete="off"
        />
        {!readOnly && (
          <div className="input-group-append polish-date-picker">
            <span className="input-group-text" aria-hidden="true">▦</span>
            <input
              type="date"
              aria-label={`Wybierz datę: ${label}`}
              value={isValidDateValue(value) ? value : ''}
              onChange={event => onChange({ target: { name, value: event.target.value } })}
              onBlur={() => onBlur({ target: { name } })}
              lang="pl"
            />
          </div>
        )}
        <div className="invalid-feedback">{error}</div>
      </div>
    </div>
  );
}

PolishDateInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
PolishDateInput.defaultProps = { value: '', readOnly: false, error: undefined };

export default PolishDateInput;
